import React from "react";
import {
  Flex,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { MdClose } from "react-icons/md";
import AllPartConfirmationsView from "./AllPartConfirmationsView";

interface AllPartConfirmationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  orderNo: string;
}

const AllPartConfirmationsModal: React.FC<AllPartConfirmationsModalProps> = ({
  isOpen,
  onClose,
  orderNo,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="xl"
        h="80vh"
        maxH="800px"
        minH="500px"
        overflow="hidden"
      >
        <ModalHeader
          borderBottom="1px solid"
          borderBottomColor="gray.200"
          py={3}
          px={5}
        >
          <Flex align="center" justify="space-between">
            <HStack spacing={3}>
              <Text
                fontSize="lg"
                fontWeight="800"
                color="gray.800"
                fontFamily="'Nunito','Inter', sans-serif"
                textTransform="uppercase"
                letterSpacing="wide"
              >
                All Part Confirmation Requests
              </Text>
              <Flex
                align="center"
                bg="purple.50"
                border="1px solid"
                borderColor="purple.200"
                px={3}
                py={1}
                borderRadius="full"
              >
                <Text
                  fontSize="0.9rem"
                  fontWeight="800"
                  color="purple.700"
                  fontFamily="'Nunito','Inter', sans-serif"
                  textTransform="uppercase"
                >
                  Enquiry: {orderNo}
                </Text>
              </Flex>
            </HStack>
            <IconButton
              aria-label="Close modal"
              icon={<MdClose size={20} />}
              onClick={onClose}
              variant="ghost"
              size="sm"
              borderRadius="full"
            />
          </Flex>
        </ModalHeader>
        <ModalBody p={4} display="flex" flex={1} overflow="hidden" bg="gray.50">
          <AllPartConfirmationsView isOpen={isOpen} orderNo={orderNo} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AllPartConfirmationsModal;
